export enum StatusWorkOrderEnum {
  New = 1,
  Sent = 2,
  Booked = 3,
  Resolved = 4,
  Completed = 5,
  Declined = 6
}

export enum StatusVehicleAlarmEnum {
  Active = 0,
  Completed = 1
}

export enum PriorityDeviationEnum {
  None = 0,
  Low = 1,
  Medium = 2,
  High = 3
}
